module.exports = {"markup":"<span class=\"inline-profile-36 inline-icon\"><svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\"><path d=\"M9 7.3c1.6 0 3.4-1.8 3.4-3.9s-1.3-3.4-3.4-3.4-3.4 1.3-3.4 3.4 2 3.9 3.4 3.9zm5.9 3.4l-.9-.8c-1.7-.6-3.1-.9-5-.9s-3.3.3-5 .9l-.9.9-2.1 6.4.9.8h14.3l.9-.9-2.2-6.4z\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./dev/webpack-loaders/svg-loader!./static/src/inline-svgs/icon/profile-36.svg
// module id = 278
// module chunks = 0 1 16